import { createRouter, createWebHistory } from "vue-router"
import { useAuthStore } from '@/stores/auth.js'
import { inject } from 'vue';
import routes from './routes.js'
const router = createRouter({
  history: createWebHistory(),
  routes: routes,
});



router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  if((to.meta.requiresAuth || to.meta.isGuest) && !authStore.currentUser) {
    await authStore.attempt_user() // make at least an attempt to get the user
  }

  if(to.meta.requiresAuth && !authStore.currentUser) {
    authStore.set_intended_url(to.fullPath)
    return next({ name: "Login" })
  }

  if (to.meta.requiresPlatformAdmin && !authStore.currentUser?.admin) {
    return next({ name: 'AccessDenied' })
  }

  if(to.meta.requiresOrganizationAccount && !authStore.hasOrganizationAccess) {
    return next({ name: 'DashboardPage' })
  }

  if (to.meta.isGuest && authStore.currentUser) {
    return next({ name: "Home" })
  }

  next()
});

router.afterEach((to, from, failure) => {
  if (!failure) {
    setTimeout(() => {
      window.HSStaticMethods.autoInit();
    }, 900)
  }
});
export default router;
